import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";
import { ObjectTarget } from "../../app/permissions";

export interface SelectedConversation {
    meObjectTarget: ObjectTarget;
    meTargetId: string;
    conversationId: string;
    title: string;
    avatar?: string;
    subtitle?: string;
    subavatar?: string;
}        

export interface SelectedConversationState {
    conversation?: SelectedConversation;
}

const initialState: SelectedConversationState = {
};

export const selectedConversationSlice = createSlice({
    name: "selectedConversation",
    initialState,
    // The `reducers` field lets us define reducers and generate associated actions
    reducers: {
        selectConversation: (state, action) => {
            state.conversation = action.payload;
        },
        clean: (state) => {
            state.conversation = undefined;
        }
    },
    // The `extraReducers` field lets the slice handle actions defined elsewhere,
    // including actions generated by createAsyncThunk or in other slices.
    // extraReducers: (builder) => {
    // },
});

// export const { } = selectedConversationSlice.actions;

export const selectedConversationState = (state: RootState) => state.selectedConversation;

export default selectedConversationSlice.reducer;
